import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { OffersService } from 'app/services/offers/offers.service';
import { Approval } from 'ng2-app/models/dto/approval/approval.model';
import { take } from 'rxjs/operators';
import { ApprovalAdjustment } from 'ng2-app/models/dto/approval/approval-adjustment.model';
import { Subject, Observable, takeUntil } from 'rxjs';
import { Store, Select } from '@ngxs/store';
import { GetApprovals, GetApprovalCalculatorStorage } from 'app/store/offers/approvals.actions';
import { ApprovalsState } from 'app/store/offers/approvals.state';

@Component({
  selector: 'app-approval-smart',
  templateUrl: './approval-smart.component.html',
  styleUrls: ['./approval-smart.component.scss'],
})
export class ApprovalSmartComponent implements OnInit, OnDestroy {
  loading = {};
  errored = {};
  calcChannels = {};
  approvals: Approval[] | null;

  @Input() approvalsCount: number;
  @Input() approval: Approval;
  @Input() borrowerId: number;
  @Input() customControlsDisabled = false;
  @Input() expandIfSolo = false;
  @Input() readOnly: boolean = false;
  @Input() useStoreApprovals: boolean = true;
  @Input() hideHeader: boolean = false;
  @Input() hideCreateOptionButton: boolean = false;
  @Input() editModalOverrideData: object = {};

  @Select(ApprovalsState.approvals) approvals$: Observable<Approval[]>;

  @Output()calculationUpdate = new EventEmitter<object>();

  private ngUnsubscribe = new Subject<boolean>();

  constructor(private offersService: OffersService, private store: Store) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    if (this.useStoreApprovals) {
      this.store.dispatch(new GetApprovals(this.borrowerId));
      this.approvals$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
        this.approvals = res;
      });
      this.approvals?.forEach(item => {
        if (item.id === this.approval.id) {
          this.approval = item;
        }
      });
      this.store.dispatch(new GetApprovalCalculatorStorage());
    }
  }

  handleAdjustedApproval({ amount, points, term, frequency, origination, approvalId }: ApprovalAdjustment) {
    this.loading[approvalId] = true; // change to object structure w/ approval id

    return this.offersService
      .getAdjustedApproval(approvalId, amount, term, points, frequency, origination)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          if (!res || !res.channel) {
            this.errored[approvalId] = true;
            // Should test this out and provide an error state if this ever actually happens
            return;
          }

          this.calcChannels[approvalId] = res.channel;
        },
        error: (res) => {
          this.loading[approvalId] = false;
          this.errored[approvalId] = true;
        },
      });
  }

  getLoading(approvalId: number) {
    if (!this.loading[approvalId]) {
      return false;
    }

    return this.loading[approvalId];
  }

  getErrored(approvalId: number) {
    if (!this.errored[approvalId]) {
      return false;
    }

    return this.errored[approvalId];
  }

  setErrored(approvalId: number) {
    this.errored[approvalId] = true;
  }

  getCalcChannel(approvalId: number) {
    if (!this.calcChannels[approvalId]) {
      return null;
    }

    return this.calcChannels[approvalId];
  }

  handlePusherPayloadReceived(approvalId: number): void {
    this.loading[approvalId] = false;
  }

  handleCalculationUpdate($event){
    this.calculationUpdate.emit($event);
  }
}
